import { Grid } from '@mui/material';
import { ShadowDivider } from '@shared/styledComponents';
import { DialogSection, GridContainer, RoleDialogContent, RoleModalSectionHeader } from '@styles/Admin-tools/Roles/RoleModalStyles';

interface IRoleModalLayoutProps {
  roleName: string;
  teamSelectorsSlot: JSX.Element;
  usersStateManagementSlot: JSX.Element;
  finalUsersSlot: JSX.Element;
}

export const RoleModalLayout = ({
  roleName,
  teamSelectorsSlot,
  usersStateManagementSlot,
  finalUsersSlot,
}: IRoleModalLayoutProps) => (
  <>
    <RoleDialogContent>
      <GridContainer container spacing={2}>
        <Grid item xs={8} xl={7}>
          <DialogSection elevation={0}>
            <RoleModalSectionHeader>Select Groups/Users for "{roleName}" Role</RoleModalSectionHeader>

            <ShadowDivider />

            <Grid container spacing={2} >
              <Grid item xs={6} xl={5} sx={{ height: '100%' }}>
                {teamSelectorsSlot}
              </Grid>

              <Grid item xs={6} xl={7} sx={{ height: '100%' }}>
                {usersStateManagementSlot}
              </Grid>
            </Grid>
          </DialogSection>
        </Grid>

        <Grid item xs={4} xl={5}>
          <DialogSection elevation={0}>{finalUsersSlot}</DialogSection>
        </Grid>
      </GridContainer>
    </RoleDialogContent>
  </>
);
